import { Spin, BackTop } from 'antd';

import classNames from 'classnames';
import parse from 'html-react-parser';

import useQuery from '../../../../util/useQuery';
import { DateTime } from 'luxon';
import { convertToISODateTime } from '../../../../util/util';

export default function PreviewArticle({ lang, detail, mode, loading, logo }) {
    const params = useQuery();

    const cctvPolicy = detail?.cctvPolicy;
    const cctvIntroductionLawfulBasis = detail?.cctvIntroductionLawfulBasis;
    const cctvPersonalDataCollect = detail?.cctvPersonalDataCollect;
    const cctvReasonCollectedData = detail?.cctvReasonCollectedData;
    const cctvTransferPersonalData = detail?.cctvTransferPersonalData;
    const cctvRetainPersonalData = detail?.cctvRetainPersonalData;
    const cctvDataSubjectRight = detail?.cctvDataSubjectRight;
    const cctvPolicyChange = detail?.cctvPolicyChange;

    const effectiveDate = convertToISODateTime(cctvPolicy?.effectiveDate);

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {cctvPolicy?.cctvCompanyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            lang === 'TH'
                                                ? cctvPolicy?.cctvPolicyNameTh ||
                                                  '-'
                                                : cctvPolicy?.cctvPolicyNameEn ||
                                                  '-'
                                        }
                                    />
                                )}
                                <h3>
                                    {lang === 'TH'
                                        ? cctvPolicy?.cctvPolicyNameTh || '-'
                                        : cctvPolicy?.cctvPolicyNameEn || '-'}
                                </h3>

                                {cctvIntroductionLawfulBasis?.cctvIntroductionIsDisplay && (
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvIntroductionLawfulBasis?.cctvIntroductionContentTh ||
                                                      '-'
                                                    : cctvIntroductionLawfulBasis?.cctvIntroductionContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                )}
                            </div>
                            {/* step 2 */}
                            {cctvIntroductionLawfulBasis?.cctvLawfulBasisIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvIntroductionLawfulBasis?.cctvLawfulBasisTitleTh ||
                                              '-'
                                            : cctvIntroductionLawfulBasis?.cctvLawfulBasisTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvIntroductionLawfulBasis?.cctvLawfulBasisContentTh ||
                                                      '-'
                                                    : cctvIntroductionLawfulBasis?.cctvLawfulBasisContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}

                            {/* step 3 */}
                            {cctvPersonalDataCollect?.cctvPersonalDataIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvPersonalDataCollect?.cctvPersonalDataTitleTh ||
                                              '-'
                                            : cctvPersonalDataCollect?.cctvPersonalDataTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvPersonalDataCollect?.cctvPersonalDataContentTh ||
                                                      '-'
                                                    : cctvPersonalDataCollect?.cctvPersonalDataContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cctvPersonalDataCollect?.cctvSourceIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvPersonalDataCollect?.cctvSourceTitleTh ||
                                              '-'
                                            : cctvPersonalDataCollect?.cctvSourceTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvPersonalDataCollect?.cctvSourceContentTh ||
                                                      '-'
                                                    : cctvPersonalDataCollect?.cctvSourceContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}

                            {/* step 4 */}
                            {cctvReasonCollectedData?.cctvPurposeIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvReasonCollectedData?.cctvPurposeTitleTh ||
                                              '-'
                                            : cctvReasonCollectedData?.cctvPurposeTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvReasonCollectedData?.cctvPurposeContentTh ||
                                                      '-'
                                                    : cctvReasonCollectedData?.cctvPurposeContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}

                            {/* step 5 */}
                            {cctvTransferPersonalData?.cctvDisclosureIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvTransferPersonalData?.cctvDisclosureTitleTh ||
                                              '-'
                                            : cctvTransferPersonalData?.cctvDisclosureTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvTransferPersonalData?.cctvDisclosureContentTh ||
                                                      '-'
                                                    : cctvTransferPersonalData?.cctvDisclosureContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cctvTransferPersonalData?.cctvInternationalIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvTransferPersonalData?.cctvInternationalTitleTh ||
                                              '-'
                                            : cctvTransferPersonalData?.cctvInternationalTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvTransferPersonalData?.cctvInternationalContentTh ||
                                                      '-'
                                                    : cctvTransferPersonalData?.cctvInternationalContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}

                            {/* step 6 */}
                            {cctvRetainPersonalData?.cctvRetentionIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvRetainPersonalData?.cctvRetentionTitleTh ||
                                              '-'
                                            : cctvRetainPersonalData?.cctvRetentionTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvRetainPersonalData?.cctvRetentionContentTh ||
                                                      '-'
                                                    : cctvRetainPersonalData?.cctvRetentionContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cctvRetainPersonalData?.cctvSecurityIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvRetainPersonalData?.cctvSecurityTitleTh ||
                                              '-'
                                            : cctvRetainPersonalData?.cctvSecurityTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvRetainPersonalData?.cctvSecurityContentTh ||
                                                      '-'
                                                    : cctvRetainPersonalData?.cctvSecurityContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}

                            {/* step 7 */}
                            {cctvDataSubjectRight?.cctvDataSubjectRightIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvDataSubjectRight?.cctvDataSubjectRightTitleTh ||
                                              '-'
                                            : cctvDataSubjectRight?.cctvDataSubjectRightTitleEn ||
                                              '-'}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvDataSubjectRight?.cctvDataSubjectRightContentTh ||
                                                      '-'
                                                    : cctvDataSubjectRight?.cctvDataSubjectRightContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}

                            {/* step 8 */}
                            {cctvPolicyChange?.cctvChangeIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvPolicyChange?.cctvChangeTitleTh
                                            : cctvPolicyChange?.cctvChangeTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvPolicyChange?.cctvChangeContentTh ||
                                                      '-'
                                                    : cctvPolicyChange?.cctvChangeContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cctvPolicyChange?.cctvDataControllerIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvPolicyChange?.cctvDataControllerTitleTh
                                            : cctvPolicyChange?.cctvDataControllerTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvPolicyChange?.cctvDataControllerContentTh ||
                                                      '-'
                                                    : cctvPolicyChange?.cctvDataControllerContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cctvPolicyChange?.cctvDataProtectionIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cctvPolicyChange?.cctvDataProtectionTitleTh
                                            : cctvPolicyChange?.cctvDataProtectionTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cctvPolicyChange?.cctvDataProtectionContentTh ||
                                                      '-'
                                                    : cctvPolicyChange?.cctvDataProtectionContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            <h4>
                                {lang === 'TH'
                                    ? 'ฉบับ ณ วันที่'
                                    : 'Edition as of'}{' '}
                                {effectiveDate
                                    ? lang === 'TH'
                                        ? DateTime.fromISO(effectiveDate, {
                                              locale: 'th',
                                          }).toLocaleString(DateTime.DATE_FULL)
                                        : DateTime.fromISO(effectiveDate, {
                                              locale: 'en',
                                          }).toLocaleString(DateTime.DATE_FULL)
                                    : '-'}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
            <div hidden={!mode}>
                <BackTop style={{ zIndex: 100000 }}>
                    <div
                        className="flex items-center justify-center !bg-[#1890ff]"
                        style={style}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </BackTop>
            </div>
        </Spin>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
